import PropTypes from 'prop-types';
import React from 'react';
import BrIcons from '@components/BrIcons';
import ColorStyles from '@components/ColorStyles';

export default function DeletableLinkColumn({ row, col, cell }) {
  const { isTruncated, isExternal, onDelete } = col.columnConfig;

  const { value } = cell;
  const clickValue = cell.clickValue || value;
  const displayValue = !isTruncated ? value : value.substring(value.indexOf('/', 10));

  return (
    <div className="deletable-link-column">
      <a dir="auto" onClick={() => col.columnConfig.onClick(row, clickValue)}>
        {displayValue}
      </a>
      {isExternal && (
        <a href={value} target="_blank" rel="noreferrer">
          <BrIcons.Extlink colorStyle={ColorStyles.BLUE} />
        </a>
      )}
      <div className="flexdiv" />
      {onDelete && <BrIcons.Delete className="del-row-icon" onClick={() => onDelete(row, clickValue)} />}
    </div>
  );
}

DeletableLinkColumn.propTypes = {
  col: PropTypes.shape({
    columnConfig: PropTypes.shape({
      isTruncated: PropTypes.bool, // for url link value, truncate on first slash after the double slash
      isExternal: PropTypes.bool, // display external link icon, uses cell.value as link href
      onClick: PropTypes.func.isRequired, // (row, value) :=> {}
      onDelete: PropTypes.func, // (row, value) :=> {}  the delete icon will not be shown if this func not provided
    }).isRequired,
  }).isRequired,
  cell: PropTypes.shape({
    value: PropTypes.string.isRequired, // display text
    clickValue: PropTypes.any, // value will be used if clickValue not provided
  }).isRequired,
};
